import { render, staticRenderFns } from "./MetadataRow.vue?vue&type=template&id=d039bb16&lang=pug&"
import script from "./MetadataRow.vue?vue&type=script&lang=js&"
export * from "./MetadataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports